<form
  [formGroup]="searchForm"
  (ngSubmit)="onSearch()"
  class="search-form-container">
  <div class="search-row">
    <!-- Patient Name -->
    <div class="field-wrapper">
      <label class="field-label">Patient Name</label>
      <mat-form-field appearance="fill" class="search-field">
        <input
          matInput
          formControlName="patientName"
          placeholder="John^Doe" />
      </mat-form-field>
    </div>
    
    <!-- Patient Birth Date -->
    <div class="field-wrapper">
      <label class="field-label">Patient Birth Date</label>
      <mat-form-field appearance="fill" class="search-field">
        <input
          matInput
          [matDatepicker]="pickerBirthDate"
          formControlName="patientBirthDate" />
        <mat-datepicker-toggle matSuffix [for]="pickerBirthDate"></mat-datepicker-toggle>
        <mat-datepicker #pickerBirthDate></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Patient ID -->
    <div class="field-wrapper">
      <label class="field-label">Patient ID</label>
      <mat-form-field appearance="fill" class="search-field">
        <input
          matInput
          formControlName="patientId"
          placeholder="1234" />
      </mat-form-field>
    </div>

    <!-- Hospital Name -->
    <!-- <div class="field-wrapper">
      <label class="field-label">Hospital Name</label>
      <mat-form-field appearance="fill" class="search-field">
        <input
          matInput
          formControlName="institutionName"
          placeholder="General Hospital" />
      </mat-form-field>
    </div> -->

    <!-- Clear Button -->
    <button
      mat-icon-button
      type="button"
      (click)="onClear()"
      [disabled]="isLoading"
      class="clear-button"
      matTooltip="Clear filters">
      <mat-icon>close</mat-icon>
    </button>

    <!-- Search Button -->
    <button
      mat-icon-button
      type="submit"
      [disabled]="isLoading"
      class="search-button"
      matTooltip="Search">
      <mat-icon>search</mat-icon>
    </button>
  </div>
</form>
